import React from "react";
import { X } from "lucide-react";
import { usePermission } from "@utils/usePermission";

const PermissionGuard = ({
  module,
  action = "view",
  isFlyout = false,
  onClose = null,
  flyoutId = null,
  children,
}) => {
  const perm = usePermission(module);
  console.log("user perm",module);
  console.log(perm);
  // 🧠 Handle case when permissions haven’t loaded yet
  if (!perm || Object.keys(perm).length === 0) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-120px)] bg-gray-50 text-gray-500">
        <div className="text-center">
          <h2 className="text-base font-medium">Loading permissions...</h2>
        </div>
      </div>
    );
  }

  const allowed =
    perm?.module_access === "yes" &&
    (perm?.[action] === "yes" || action === "module_access");

  // ❌ Access Denied — Flyout mode
  if (!allowed && isFlyout) {
    return (
      <div className="modal-panel size-sm fixed top-[50px] right-0 h-[calc(100vh-56px)] bg-white shadow-lg z-50 flex flex-col w-screen max-w-full md:w-[480px]">
        <div className="sticky top-0 z-10 bg-gray-50 border-b p-3 shadow-sm flex justify-between items-center">
          <h2 className="text-lg text-gray-700 font-regular pl-3">Access Denied</h2>
          {onClose && (
            <button
              onClick={onClose}
              className="absolute -left-3 rounded-full bg-white w-[28px] h-[28px] shadow-lg flex items-center justify-center"
            >
              <X size={16} />
            </button>
          )}
        </div>
        <div className="flex flex-col justify-center items-center flex-1 px-4 text-center">
          <p className="text-gray-700 text-sm mb-2">
            You don’t have permission to access this section.
          </p>
        </div>
      </div>
    );
  }

  // ❌ Access Denied — Full Page mode
  if (!allowed) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-120px)] bg-gray-50 text-gray-600">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">Access Denied</h2>
          <p className="text-sm">You don’t have permission to access this section.</p>
        </div>
      </div>
    );
  }

  // ✅ Access allowed
  return children;
};

export default PermissionGuard;
